import axios from "axios";
import constants from "@/constants";
import { getAuth, onAuthStateChanged } from "firebase/auth";

const url = `${constants.apiUrl}`;

class CustomerGetters {
  static async companyInquiries(companyId, tab) {
    try {
      return new Promise((resolve, reject) => {
        const auth = getAuth();
        const unsubscribe = onAuthStateChanged(auth, (user) => {
          if (user) {
            auth.currentUser
              .getIdToken(/* forceRefresh */ true)
              .then((idToken) => {
                const url = `${constants.apiUrl}/travel-enquiry-getters/company-inquiries/${companyId}?status=${tab}`;
                const config = {
                  headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                    Authorization: `Bearer ${idToken}`,
                  },
                };

                axios
                  .get(url, config)
                  .then((response) => {
                    const data = response.data;
                    unsubscribe();
                    resolve(data);
                  })
                  .catch((error) => {
                    reject(error);
                  });
              })
              .catch((err) => {
                reject(err);
              });
          } else {
            reject("user not found");
          }
        });
      });
    } catch (error) {
      return error;
    }
  }

  static async inquiryById(inquiryId, companyId) {
    try {
      return new Promise((resolve, reject) => {
        const auth = getAuth();
        const unsubscribe = onAuthStateChanged(auth, (user) => {
          if (user) {
            auth.currentUser
              .getIdToken(/* forceRefresh */ true)
              .then((idToken) => {
                const url = `${constants.apiUrl}/travel-enquiry-getters/company-inquiry-by-id/${inquiryId}/${companyId}`;
                const config = {
                  headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                    Authorization: `Bearer ${idToken}`,
                  },
                };

                axios
                  .get(url, config)
                  .then((response) => {
                    const data = response.data;
                    unsubscribe();
                    resolve(data);
                  })
                  .catch((error) => {
                    reject(error);
                  });
              })
              .catch((err) => {
                reject(err);
              });
          } else {
            reject("user not found");
          }
        });
      });
    } catch (error) {
      return error;
    }
  }
}

export default CustomerGetters;
